import { render, staticRenderFns } from "./OverlayError.vue?vue&type=template&id=21fef5ad&"
import script from "./OverlayError.vue?vue&type=script&lang=js&"
export * from "./OverlayError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fef5ad')) {
      api.createRecord('21fef5ad', component.options)
    } else {
      api.reload('21fef5ad', component.options)
    }
    module.hot.accept("./OverlayError.vue?vue&type=template&id=21fef5ad&", function () {
      api.rerender('21fef5ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/OverlayError.vue"
export default component.exports